import jQuery from 'jquery';

jQuery(function ($) {
  const $slickHome = $('.home-slider');

  $slickHome.slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    dots: false,
    speed: 700,
    swipeToSlide: true,
    accessibility: false,
    centerPadding: 0,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  });
});
